import React, { useEffect } from 'react';
import Select from './Select';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { Grid } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import { useSelector, useDispatch } from "react-redux";
import { 
	GET_STATS_REQUEST, 
	GET_LOCATION_REQUEST,
	UPDATE_SECTOR,
  } from 'redux/reducers/SectorDetail/actionTypes'
import { GET_LIST_SECTOR_DETAIL_REQUEST } from 'redux/reducers/SectorDetail/actionTypes';
import { routes } from 'routers/routes';
import { useHistory } from "react-router-dom";


const InputSearch = () =>{
	const sector = useSelector(state => state.Product);

	const isLoginUser = useSelector(state => state.User.islogin);
  const useLoginStorage = useSelector(state => state.User.user_storage);
  const useLoginProfile = useSelector(state => state.User.user_login);

	let history = useHistory();
	const dispatch = useDispatch();
	useEffect(() => {
		if(sector.chosenProduct && sector.chosenTier2 && sector.chosenTier3 && sector.isStats)
		{
			getStats();
		}
		if(sector.chosenProduct && sector.chosenTier2 && sector.chosenTier3 && sector.chosenStat && sector.isLocation)
		{
		  getLocation();
		}
		
	  }, [sector.chosenStat]);
	useEffect(() => {
	if(sector.chosenTier3 != null)
	{
		getStats();
	}
	}, [sector.chosenTier3]);
	const getStats = () =>{
		dispatch({
		  type: GET_STATS_REQUEST,
		  pms :{
			product         : (sector.chosenProduct && sector.chosenProduct.id) ? sector.chosenProduct.id : '',
			sub_category_1  : (sector.chosenTier2 && sector.chosenTier2.id) ? sector.chosenTier2.id : '',
			sub_category_2  : (sector.chosenTier3 && sector.chosenTier3.id) ? sector.chosenTier3.id : ''
		  }
		});
	  }
	  const getLocation = () =>{
		dispatch({
		  type: GET_LOCATION_REQUEST,
		  pms :{
			product         : (sector.chosenProduct && sector.chosenProduct.id) ? sector.chosenProduct.id : '',
			sub_category_1  : (sector.chosenTier2 && sector.chosenTier2.id) ? sector.chosenTier2.id : '',
			sub_category_2  : (sector.chosenTier3 && sector.chosenTier3.id) ? sector.chosenTier3.id : '',
			stats_id        : sector.chosenStat &&  sector.chosenStat.id  ? sector.chosenStat.id : null,
			stats_type      : sector.chosenStat &&  sector.chosenStat.type ? sector.chosenStat.type : ''
		  }
		});
	  }
	  const selectSector = (e) =>{
		let productId = sector.sectorDetail.sector_data[e.id].children[0].id;
		dispatch({
		  type:UPDATE_SECTOR,
		  
		  
		  chosenSector    : e,
		  chosenProduct   : sector.sectorDetail.sector_data[e.id].children[0],
		  // sectorProducts  : sector.sectorProducts,
		  sectorProducts  : (productId != null) ? sector.sectorDetail.sector_data[e.id].children : [],
		  tier2List       : (productId != null) ? sector.sectorDetail.product_data[productId].children : [],
		  chosenTier2     : null,
		  tier3List       : [],
		  chosenTier3     : null,
		  //*stats
	
		  statList        : [],
		  chosenStat      : null,
		  //*country
	
		  locationList    : [],
		  chosenCountry   : null,
		  provinceList    : [],
		  chosenProvince  : null,
		  CityList        : [],
		  chosenCity      : null
		})
	  }
	  const selectProduct = (e) =>{
		dispatch({
		  type:UPDATE_SECTOR,
		  
		  
		  chosenSector    : sector.chosenSector,
		  chosenProduct   : e,
		  sectorProducts  : sector.sectorProducts,
		  tier2List       :  sector.sectorDetail.product_data[e.id].children  ? sector.sectorDetail.product_data[e.id].children : [],
		  chosenTier2     : null,
		  tier3List       : [],
		  chosenTier3     : null,
		  //*stats
	
		  statList        : [],
		  chosenStat      : null,
		  //*country
	
		  locationList    : [],
		  chosenCountry   : null,
		  provinceList    : [],
		  chosenProvince  : null,
		  CityList        : [],
		  chosenCity      : null
		})
	  }
	  const selectTier2 = (e) =>{
	   
		dispatch({
		  type:UPDATE_SECTOR,
		  
		  
		  chosenSector    : sector.chosenSector,
		  chosenProduct   : sector.chosenProduct,
		  sectorProducts  : sector.sectorProducts,
		  tier2List       : sector.tier2List,
		  chosenTier2     : e,
		  tier3List       : sector.sectorDetail.sub_category_1_data[e.id].children ? sector.sectorDetail.sub_category_1_data[e.id].children : [],
		  chosenTier3     : null,
		  //*stats
	
		  statList        : [],
		  chosenStat      : null,
		  //*country
	
		  locationList    : [],
		  chosenCountry   : null,
		  provinceList    : [],
		  chosenProvince  : null,
		  CityList        : [],
		  chosenCity      : null
		})
	  }
	  const selectTier3 = (e) =>{
		dispatch({
		  type:UPDATE_SECTOR,
		  
		  
		  chosenSector    :sector.chosenSector,
		  chosenProduct   :sector.chosenProduct,
		  sectorProducts  :sector.sectorProducts,
		  tier2List       :sector.tier2List,
		  chosenTier2     :sector.chosenTier2,
		  tier3List       : sector.tier3List,
		  chosenTier3     : JSON.parse(JSON.stringify(e)),
		  //*stats
	
		  statList        : [],
		  chosenStat      : null,
		  //*country
	
		  locationList    : [],
		  chosenCountry   :  {id: '', name: 'Loading...'},
		  provinceList    : [],
		  chosenProvince  : null,
		  CityList        : [],
		  chosenCity      : null
		})
		//getStats();
	  }
	  const selectCountry = (e) =>{
		dispatch({
		  type:UPDATE_SECTOR,
	
		  chosenSector    :sector.chosenSector,
		  chosenProduct   :sector.chosenProduct,
		  sectorProducts  :sector.sectorProducts,
		  tier2List       :sector.tier2List,
		  chosenTier2     :sector.chosenTier2,
		  tier3List       :sector.tier3List,
		  chosenTier3     :sector.chosenTier3,
		  //*stats
	
		  statList    : sector.statList,
		  chosenStat  : sector.chosenStat,
		  //*country
	
		  locationList    : sector.locationList,
		  chosenCountry   : e,
		  provinceList    : sector.locationList.country_data[e.id].children,
		  chosenProvince  : null,
		  CityList        : [],
		  chosenCity      : null
		})
		
	  }
	useEffect(() => {
		  if(isLoginUser && useLoginStorage && useLoginStorage.subscription_plan_total > 0  || isLoginUser && useLoginProfile && useLoginProfile.subscription_plan_total > 0) {
				
				if(!sector.chosenSector && !sector.chosenProduct && !sector.chosenTier2 && !sector.chosenTier3 && !sector.chosenCountry)
				{
					dispatch({
						type: GET_LIST_SECTOR_DETAIL_REQUEST,
					});
				}

			}
			
	}, []);  
	useEffect(() => {
		if(sector.chosenProduct && sector.chosenTier2 && sector.chosenTier3 && sector.isStats)
		{
			getStats();
		}
	
		if(sector.chosenProduct && sector.chosenTier2 && sector.chosenTier3 && sector.chosenStat && sector.isLocation)
		{
		  getLocation();
		}
		
		
	  }, [sector]);
	const [listProducts, setListProducts] = React.useState([{"id":32,"title":"Feed","total":0,"created_at":"2018-11-30 11:20:26","updated_at":"2019-07-12 08:32:51","position":3,"translations":[{"id":118,"sector_id":32,"title":"\u9972\u6599","locale":"ch","created_at":"2018-12-01 03:49:15","updated_at":"2018-12-01 03:49:15"},{"id":114,"sector_id":32,"title":"Feed","locale":"en","created_at":"2018-11-30 11:20:26","updated_at":"2018-11-30 11:20:26"},{"id":131,"sector_id":32,"title":"","locale":"id","created_at":"2019-07-02 08:48:04","updated_at":"2019-07-02 08:48:04"},{"id":132,"sector_id":32,"title":"","locale":"th","created_at":"2019-07-02 08:48:04","updated_at":"2019-07-02 08:48:04"},{"id":133,"sector_id":32,"title":"","locale":"vi","created_at":"2019-07-02 08:48:04","updated_at":"2019-07-02 08:48:04"},{"id":123,"sector_id":32,"title":"\u9972\u6599","locale":"zh","created_at":"2018-12-05 07:48:13","updated_at":"2019-07-02 08:48:04"}],"sector_id":32},{"id":29,"title":"Feed Additives","total":0,"created_at":"2018-11-30 11:18:32","updated_at":"2019-07-18 04:14:50","position":2,"translations":[{"id":115,"sector_id":29,"title":"\u9972\u6599\u6dfb\u52a0\u5242","locale":"ch","created_at":"2018-12-01 03:48:28","updated_at":"2018-12-01 03:48:28"},{"id":111,"sector_id":29,"title":"Feed Additives","locale":"en","created_at":"2018-11-30 11:18:32","updated_at":"2018-11-30 11:18:32"},{"id":124,"sector_id":29,"title":"","locale":"id","created_at":"2019-06-14 04:04:24","updated_at":"2019-06-14 04:04:24"},{"id":125,"sector_id":29,"title":"","locale":"th","created_at":"2019-06-14 04:04:24","updated_at":"2019-06-14 04:04:24"},{"id":126,"sector_id":29,"title":"","locale":"vi","created_at":"2019-06-14 04:04:24","updated_at":"2019-06-14 04:04:24"},{"id":122,"sector_id":29,"title":"\u9972\u6599\u6dfb\u52a0\u5242","locale":"zh","created_at":"2018-12-05 07:46:53","updated_at":"2019-06-14 04:04:24"}],"sector_id":29},{"id":31,"title":"Feed Grains","total":0,"created_at":"2018-11-30 11:19:58","updated_at":"2019-07-18 04:14:50","position":1,"translations":[{"id":117,"sector_id":31,"title":"\u5927\u5b97\u539f\u6599","locale":"ch","created_at":"2018-12-01 03:49:01","updated_at":"2018-12-01 03:49:01"},{"id":113,"sector_id":31,"title":"Feed Grains","locale":"en","created_at":"2018-11-30 11:19:58","updated_at":"2018-12-20 10:08:16"},{"id":134,"sector_id":31,"title":"","locale":"id","created_at":"2019-07-02 08:48:33","updated_at":"2019-07-02 08:48:33"},{"id":135,"sector_id":31,"title":"","locale":"th","created_at":"2019-07-02 08:48:33","updated_at":"2019-07-02 08:48:33"},{"id":136,"sector_id":31,"title":"","locale":"vi","created_at":"2019-07-02 08:48:33","updated_at":"2019-07-02 08:48:33"},{"id":121,"sector_id":31,"title":"\u9972\u6599\u8c37\u7269","locale":"zh","created_at":"2018-12-03 06:25:49","updated_at":"2019-07-02 08:48:33"}],"sector_id":31},{"id":30,"title":"Livestock","total":0,"created_at":"2018-11-30 11:18:55","updated_at":"2019-07-12 08:37:20","position":4,"translations":[{"id":116,"sector_id":30,"title":"\u755c\u7267","locale":"ch","created_at":"2018-12-01 03:48:38","updated_at":"2018-12-01 03:48:38"},{"id":112,"sector_id":30,"title":"Livestock","locale":"en","created_at":"2018-11-30 11:18:55","updated_at":"2018-11-30 11:18:55"},{"id":127,"sector_id":30,"title":"","locale":"id","created_at":"2019-07-02 05:48:15","updated_at":"2019-07-02 05:48:15"},{"id":128,"sector_id":30,"title":"","locale":"th","created_at":"2019-07-02 05:48:15","updated_at":"2019-07-02 05:48:15"},{"id":129,"sector_id":30,"title":"","locale":"vi","created_at":"2019-07-02 05:48:15","updated_at":"2019-07-02 05:48:15"},{"id":130,"sector_id":30,"title":"\u755c\u7267","locale":"zh","created_at":"2019-07-02 05:48:15","updated_at":"2019-07-02 05:48:15"}],"sector_id":30},{"id":33,"title":"Macro Ingredients","total":0,"created_at":"2018-12-03 06:20:40","updated_at":"2019-07-12 08:37:20","position":5,"translations":[{"id":120,"sector_id":33,"title":"\u5927\u5b97\u539f\u6599","locale":"ch","created_at":"2018-12-03 06:20:40","updated_at":"2018-12-03 06:20:40"},{"id":119,"sector_id":33,"title":"Macro Ingredients","locale":"en","created_at":"2018-12-03 06:20:40","updated_at":"2018-12-03 06:20:40"},{"id":137,"sector_id":33,"title":"","locale":"id","created_at":"2019-07-02 08:48:48","updated_at":"2019-07-02 08:48:48"},{"id":138,"sector_id":33,"title":"","locale":"th","created_at":"2019-07-02 08:48:48","updated_at":"2019-07-02 08:48:48"},{"id":139,"sector_id":33,"title":"","locale":"vi","created_at":"2019-07-02 08:48:48","updated_at":"2019-07-02 08:48:48"},{"id":140,"sector_id":33,"title":"\u5927\u5b97\u539f\u6599","locale":"zh","created_at":"2019-07-02 08:48:48","updated_at":"2019-07-02 08:48:48"}],"sector_id":33}]);
	const [valueSearch, setValueSearch] = React.useState('');
	const [open, setOpen] = React.useState(false);
	
	const handleOpen = () => {
	    setOpen(true);
	  };

	  const handleClose = () => {
	    setOpen(false);
	  };

	const handleChoseProduct = (item) => {
	  };
	const btnSearchProduct = () =>{
		document.cookie = `sector_id=${sector.chosenSector.id}`;
		document.cookie = `country_id=${sector.chosenCountry.id}`;
		document.cookie = `product_id=${sector.chosenProduct.id}`;
		document.cookie = `stat_id=${sector.chosenStat.id}`;
		document.cookie = `tier2_id=${sector.chosenTier2.id}`;
		document.cookie = `tier3_id=${sector.chosenTier3.id}`;
		history.push(routes.prodetail);
		
	}
  	return (
    <Grid className="search-input" item lg={12} md={12} xs={12} sm={12}>
    	<List component="nav" className="list-box-search list-box-search-mobile" onClick={handleOpen}>
    		<input type="text" placeholder="Search for products" disabled/>
    		<SearchIcon id="icon-search"></SearchIcon>
    	</List>
    	<List component="nav" className="list-box-search">
          	<ListItem>
          		<Select
				  	value={sector.chosenSector}
                  	dataOptions={sector.sectorDetail.sectors}
					optionLabel={'title'}
					onChangeFunction={selectSector}
                />
          	</ListItem>
          	<ListItem>
          		<Select
                  	value={sector.chosenProduct}
					dataOptions={sector.sectorProducts}
					optionLabel={'title'}
					onChangeFunction={selectProduct}
                />
          	</ListItem>
          	<ListItem>
          		<Select
                  	value={sector.chosenTier2}
					dataOptions={sector.tier2List}
					optionLabel={'title'}
					onChangeFunction={selectTier2}
                />
          	</ListItem>
          	<ListItem>
          		<Select
					value={sector.chosenTier3}
					dataOptions={sector.tier3List}
					optionLabel={'title'}
					onChangeFunction={selectTier3}
                />
          	</ListItem>
          	<ListItem>
          		<Select
					value={sector.chosenCountry}
					dataOptions={sector.locationList.countries}
					optionLabel={'name'}
					onChangeFunction={selectCountry}
                />
          	</ListItem>
          	<SearchIcon className={`${sector.chosenSector && sector.chosenProduct && sector.chosenTier2 && sector.chosenTier3 && sector.chosenCountry? '': 'disable'}  `} onClick={btnSearchProduct} id="icon-search"></SearchIcon>
        </List>
        <Modal
	        aria-labelledby="transition-modal-title"
	        aria-describedby="transition-modal-description"
	        className={'popup-search'}
	        open={open}
	        onClose={handleClose}
	        closeAfterTransition
	        BackdropComponent={Backdrop}
	        BackdropProps={{
	          timeout: 500,
	        }}
	      >
	        <Fade in={open}>
	          	<form className="form-search">
	          		<label className="title">Search for products</label>
	          		<Select
	          			inputContainerClass={"form-search-input"}
	                  	value={sector.chosenSector}
						dataOptions={sector.sectorDetail.sectors}
						optionLabel={'title'}
						onChangeFunction={selectSector}
	                />
	                <Select
	                	inputContainerClass={"form-search-input"}
						value={sector.chosenProduct}
						dataOptions={sector.sectorProducts}
						optionLabel={'title'}
						onChangeFunction={selectProduct}
	                />
	                <Select
	                	inputContainerClass={"form-search-input"}
						value={sector.chosenTier2}
						dataOptions={sector.tier2List}
						optionLabel={'title'}
						onChangeFunction={selectTier2}
	                />
	                <Select
	                	inputContainerClass={"form-search-input"}
						value={sector.chosenTier3}
						dataOptions={sector.tier3List}
						optionLabel={'title'}
						onChangeFunction={selectTier3}
	                />
	                <Select
	                	inputContainerClass={"form-search-input"}
						value={sector.chosenCountry}
						dataOptions={sector.locationList.countries}
						optionLabel={'name'}
						onChangeFunction={selectCountry}
	                />
	                <Button className={`btn-general ${sector.chosenSector && sector.chosenProduct && sector.chosenTier2 && sector.chosenTier3 && sector.chosenCountry? '': 'disable'} `} variant="contained" fullWidth onClick={btnSearchProduct} >Search</Button>
	                <CloseIcon className="icon-close" onClick={handleClose}></CloseIcon>
	          	</form>
	        </Fade>
	      </Modal>
    </Grid>
  );
}
export default InputSearch;
